// extracted by mini-css-extract-plugin
module.exports = {"error-boundry":"ErrorBoundary_error-boundry__2AWca"};